import Splide from '@splidejs/splide'
import { bannerMediaImageReveal } from './mod_banner'

export function slider() {
	const sliders = []
	var elms = document.getElementsByClassName('splide')

	for (var i = 0; i < elms.length; i++) {
		const splide = new Splide(elms[i])
		splide.on('mounted', bannerMediaImageReveal)
		splide.on('moved', bannerMediaImageReveal)
		sliders.push(splide.mount())
	}

	return sliders
}
